module.exports = __webpack_public_path__ + "img/dork-radio.979d244d.png";